module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAKxJREFUKBVjYCATMIaEhGQB9RZg08/IyPiJlZXVddmyZe/R5VmYmJhs//37p4ouAeL///8fhGWBTAyNTNg0ECNGtkYWQqb/+fPnaGho6F+ouhfa2to6DQ0NfwhqBPqRB8lw/gcPHoD4H8h3KtDE60ATfiKZygZkMyLxsTIxFAD9cwBomD1W1UBBHh4ewQULFpDvVPL9iMVJx4FiyljEGYBJ8PnXr18/Y5MjWgwASzwzfeZWKPoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Step/top_combination.png
// module id = 347
// module chunks = 0